import { webDtos } from '@vectronic/openApi-customer';

export const ANIMALS: webDtos.AnimalExtended[] = [
  {
    id: 11,
    name: 'animal_11',
    label: 'label',
    colorRgbCode: '#FF5733',
    description: 'määh!',
    deployments: undefined,
    animalSex: 'MALE',
    creationTimestamp: new Date(2018, 5, 0o5, 17, 23, 42, 11).toISOString(),
    updateTimestamp: new Date(2016, 0o6, 0o5, 17, 23, 42, 11).toISOString(),
    lastReception: new Date(2018, 8, 5, 17, 23, 42, 11).toISOString(),
    role: 'OWNER',
  },
  {
    id: 12,
    name: 'animal_12',
    label: 'label',
    colorRgbCode: '#76992f',
    description: 'muuh!',
    deployments: undefined,
    animalSex: 'FEMALE',
    creationTimestamp: new Date(2016, 5, 0o5, 17, 23, 42, 11).toISOString(),
    updateTimestamp: new Date(2016, 0o6, 0o5, 17, 23, 42, 11).toISOString(),
    lastReception: new Date(2015, 8, 5, 17, 23, 42, 11).toISOString(),
    role: 'OWNER',
  },
  {
    id: 13,
    name: 'animal_13',
    label: 'label',
    colorRgbCode: '#1b44b5',
    description: 'miau!',
    deployments: undefined,
    animalSex: 'MALE',
    creationTimestamp: new Date(2018, 5, 11, 17, 23, 42, 11).toISOString(),
    updateTimestamp: new Date(2016, 6, 12, 17, 23, 42, 11).toISOString(),
    lastReception: new Date(2018, 8, 13, 17, 23, 42, 11).toISOString(),
    role: 'OWNER',
  },
  {
    id: 14,
    name: 'animal_14',
    label: 'label',
    colorRgbCode: '#db40d1',
    description: 'wuff!',
    deployments: undefined,
    animalSex: 'UNKNOWN',
    creationTimestamp: new Date(2019, 5, 11, 17, 23, 42, 11).toISOString(),
    updateTimestamp: new Date(2019, 6, 12, 17, 23, 42, 11).toISOString(),
    lastReception: new Date(2019, 8, 13, 17, 23, 42, 11).toISOString(),
    role: 'OWNER',
  },
];
